import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import { GuestState, StoreKeys } from './guestStore';

const store = (set) => ({
  [StoreKeys.GUEST_DATA]: {},
  [StoreKeys.SET_GUEST_DATA]: (guestData: GuestState['guestData']) =>
    set({ guestData }),
  [StoreKeys.CLEAR_GUEST_DATA]: (defaultValues: GuestState['guestData'] = {}) =>
    set({ guestData: { ...defaultValues } }),
  [StoreKeys.CHOOSE_TYPE]: '',
  [StoreKeys.SET_CHOOSE_TYPE]: (chooseType: string) => set({ chooseType }),
});

const guestStore = persist(store, {
  name: 'guestStore',
  storage: createJSONStorage(() => sessionStorage),
  merge: (persistedState: GuestState, currentState: GuestState) => ({
    ...currentState,
    ...persistedState,
  }),
}) as any;

export const useGuestStore = create(devtools(guestStore));
